import React, { useEffect } from "react";
import SplashScreen from "./SplashScreen";
import api from "../../store/api/api";
import { useDispatch } from "react-redux";
import { setCampaignList, setMemberships } from "../../store/actions";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../../allauth/auth";

export default function Startup() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const me = useUser();

    useEffect(() => {
        if (!me) return;
        api.get("myaccount/").then((res) => {
            console.log('pass to redux', res.data)
            const { memberships, ...account } = res.data;
            const campaigns = {};
            memberships.forEach(membership => {
                if (membership.campaign.is_active || membership.role.name === 'admin') {
                    campaigns[membership.id] = membership.campaign;
                }
            });
            dispatch(setCampaignList(Object.values(campaigns)));
            dispatch(setMemberships(memberships, account.profile));
            if (location.pathname === '/startup') {
                navigate('/select-campaign');
            }
        })
    }, [me, location.pathname]);

    return <SplashScreen />
}
